import { useCallback } from 'react';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';

const useConnectionCheck = () => {
  const {
    authInfo: { authToken },
  } = useRemoteBoundStore();

  return useCallback(async (): Promise<boolean> => {
    if (authToken) {
      return Api.remote.check_galen_connection();
    }
    try {
      const response = await fetch(`${import.meta.env.VITE_X_TENANT_DOMAIN}`, {
        signal: AbortSignal.timeout(5000),
      });
      return response.ok;
    } catch {
      return false;
    }
  }, [authToken]);
};

export default useConnectionCheck;
